var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocation = function SvgIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.364 16.514-4.773 4.82A2.25 2.25 0 0 1 10 22a2.23 2.23 0 0 1-1.59-.666l-4.775-4.82a9.1 9.1 0 0 1-2.463-4.653 9.17 9.17 0 0 1 .512-5.25A9.07 9.07 0 0 1 5 2.53 8.94 8.94 0 0 1 10 1c1.78 0 3.52.533 5 1.532a9.07 9.07 0 0 1 3.315 4.078c.681 1.66.86 3.488.512 5.251a9.1 9.1 0 0 1-2.463 4.653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.375 10.088c0 .904-.356 1.77-.989 2.41a3.36 3.36 0 0 1-2.386.998c-.895 0-1.754-.36-2.386-.998a3.43 3.43 0 0 1-.989-2.41c0-.904.356-1.77.989-2.41A3.36 3.36 0 0 1 10 6.68c.895 0 1.754.359 2.387.998.632.64.988 1.506.988 2.41"
  })));
};
export default SvgIconLocation;